import { defineComponent as z, createBlock as i, openBlock as u, withCtx as n, createVNode as r, createElementBlock as b, createTextVNode as f, toDisplayString as c, Fragment as g, renderList as q, normalizeClass as v, unref as s, createCommentVNode as k, createElementVNode as p } from "vue";
import { ScalarTooltip as D, ScalarIcon as B, ScalarButton as R } from "@scalar/components";
import { ScalarIconTrash as E } from "@scalar/icons";
import { RouterLink as G } from "vue-router";
import C from "../../../components/CodeInput/CodeInput.vue.js";
import N from "../../../components/DataTable/DataTable.vue.js";
import y from "../../../components/DataTable/DataTableCell.vue.js";
import P from "../../../components/DataTable/DataTableCheckbox.vue.js";
import V from "../../../components/DataTable/DataTableHeader.vue.js";
import $ from "../../../components/DataTable/DataTableRow.vue.js";
import { parameterIsInvalid as j, hasItemProperties as h } from "../libs/request.js";
import K from "./RequestTableTooltip.vue.js";
const O = { class: "text-c-2 filemask flex w-full max-w-[100%] items-end justify-end overflow-hidden p-1" }, A = ["onClick"], L = {
  key: 1,
  class: "p-0.5"
}, ne = /* @__PURE__ */ z({
  __name: "RequestTable",
  props: {
    items: {},
    hasCheckboxDisabled: { type: Boolean, default: !1 },
    showUploadButton: { type: Boolean, default: !1 },
    isGlobal: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    environment: {},
    envVariables: {},
    workspace: {},
    invalidParams: {},
    label: {}
  },
  emits: ["updateRow", "toggleRow", "addRow", "deleteRow", "inputFocus", "inputBlur", "uploadFile", "removeFile"],
  setup(x, { emit: F }) {
    const m = x, t = F, _ = ["", "", "36px"], w = (e, o, l) => {
      t("updateRow", e, o, l);
    }, U = (e) => {
      t("uploadFile", e);
    }, S = (e) => Array.isArray(e.default) && e.default.length === 1 ? e.default[0] : e.default, T = (e) => !!(e.key || e.value);
    return (e, o) => (u(), i(N, {
      class: "group/table flex-1",
      columns: _
    }, {
      default: n(() => [
        r($, { class: "sr-only !block" }, {
          default: n(() => [
            r(V, null, {
              default: n(() => [
                f(c(e.label) + " Enabled", 1)
              ]),
              _: 1
            }),
            r(V, null, {
              default: n(() => [
                f(c(e.label) + " Key", 1)
              ]),
              _: 1
            }),
            r(V, null, {
              default: n(() => [
                f(c(e.label) + " Value", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (u(!0), b(g, null, q(e.items, (l, d) => (u(), i($, {
          id: l.key,
          key: d,
          class: v({
            alert: s(j)(l).value,
            error: e.invalidParams && e.invalidParams.has(l.key)
          })
        }, {
          default: n(() => [
            e.isGlobal ? (u(), i(s(G), {
              key: 0,
              class: "text-c-2 flex items-center justify-center border-t !border-r",
              to: l.route ?? {}
            }, {
              default: n(() => [
                o[4] || (o[4] = p("span", { class: "sr-only" }, "Global", -1)),
                r(s(D), {
                  content: "Global cookies are shared across the whole workspace.",
                  placement: "top"
                }, {
                  default: n(() => [
                    r(s(B), {
                      tabindex: "0",
                      class: "text-c-1",
                      icon: "Globe",
                      size: "xs"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 2,
              __: [4]
            }, 1032, ["to"])) : (u(), i(P, {
              key: 1,
              class: "!border-r",
              disabled: m.hasCheckboxDisabled,
              modelValue: l.enabled,
              "onUpdate:modelValue": (a) => t("toggleRow", d, a)
            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])),
            r(y, null, {
              default: n(() => [
                r(C, {
                  "aria-label": `${e.label} Key`,
                  disableCloseBrackets: "",
                  disabled: m.isReadOnly,
                  disableEnter: "",
                  disableTabIndent: "",
                  lineWrapping: "",
                  envVariables: e.envVariables,
                  environment: e.environment,
                  modelValue: l.key,
                  placeholder: "Key",
                  required: !!l.required,
                  workspace: e.workspace,
                  onBlur: o[0] || (o[0] = (a) => t("inputBlur")),
                  onFocus: o[1] || (o[1] = (a) => t("inputFocus")),
                  onSelectVariable: (a) => w(d, "key", a),
                  "onUpdate:modelValue": (a) => t("updateRow", d, "key", a)
                }, null, 8, ["aria-label", "disabled", "envVariables", "environment", "modelValue", "required", "workspace", "onSelectVariable", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            r(y, null, {
              default: n(() => [
                r(C, {
                  "aria-label": `${e.label} Value`,
                  class: v(
                    s(h)(l) ? "pr-6 group-hover:pr-10 group-has-[.cm-focused]:pr-10" : "group-hover:pr-6 group-has-[.cm-focused]:pr-6"
                  ),
                  default: l.default,
                  disableCloseBrackets: "",
                  disabled: m.isReadOnly,
                  disableEnter: "",
                  disableTabIndent: "",
                  lineWrapping: "",
                  enum: l.enum ?? [],
                  envVariables: e.envVariables,
                  environment: e.environment,
                  examples: l.examples ?? [],
                  max: l.maximum,
                  min: l.minimum,
                  modelValue: l.value,
                  nullable: !!l.nullable,
                  placeholder: "Value",
                  type: l.type,
                  workspace: e.workspace,
                  onBlur: o[2] || (o[2] = (a) => t("inputBlur")),
                  onFocus: o[3] || (o[3] = (a) => t("inputFocus")),
                  onSelectVariable: (a) => w(d, "value", a),
                  "onUpdate:modelValue": (a) => t("updateRow", d, "value", a)
                }, {
                  icon: n(() => [
                    T(l) && !l.required ? (u(), i(s(R), {
                      key: 0,
                      class: v([{
                        "-mr-0.5": s(h)(l)
                      }, "text-c-2 hover:text-c-1 hover:bg-b-2 z-context hidden h-fit rounded p-1 group-hover:flex group-has-[.cm-focused]:flex"]),
                      size: "sm",
                      variant: "ghost",
                      onClick: (a) => t("deleteRow", d)
                    }, {
                      default: n(() => [
                        r(s(E), { class: "size-3.5" })
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"])) : k("", !0),
                    s(h)(l) ? (u(), i(K, {
                      key: 1,
                      item: { ...l, default: S(l) }
                    }, null, 8, ["item"])) : k("", !0)
                  ]),
                  _: 2
                }, 1032, ["aria-label", "class", "default", "disabled", "enum", "envVariables", "environment", "examples", "max", "min", "modelValue", "nullable", "type", "workspace", "onSelectVariable", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            e.showUploadButton ? (u(), i(y, {
              key: 2,
              class: "group/upload flex items-center justify-center whitespace-nowrap"
            }, {
              default: n(() => {
                var a;
                return [
                  l.file ? (u(), b(g, { key: 0 }, [
                    p("div", O, [
                      p("span", null, c((a = l.file) == null ? void 0 : a.name), 1)
                    ]),
                    p("button", {
                      class: "bg-b-2 centered-x centered-y absolute hidden w-[calc(100%_-_8px)] rounded p-0.5 text-center text-xs font-medium group-hover/upload:block",
                      type: "button",
                      onClick: (I) => t("removeFile", d)
                    }, " Delete ", 8, A)
                  ], 64)) : (u(), b("div", L, [
                    r(s(R), {
                      class: "bg-b-2 hover:bg-b-3 text-c-2 h-fit border-0 py-px shadow-none",
                      size: "sm",
                      variant: "outlined",
                      onClick: (I) => U(d)
                    }, {
                      default: n(() => [
                        o[5] || (o[5] = p("span", null, "Upload File", -1)),
                        r(s(B), {
                          class: "ml-1",
                          icon: "Upload",
                          size: "xs",
                          thickness: "2.5"
                        })
                      ]),
                      _: 2,
                      __: [5]
                    }, 1032, ["onClick"])
                  ]))
                ];
              }),
              _: 2
            }, 1024)) : k("", !0)
          ]),
          _: 2
        }, 1032, ["id", "class"]))), 128))
      ]),
      _: 1
    }));
  }
});
export {
  ne as default
};
